import { type RestApiClient } from '@docyrus/api-client';

import { useDocyrusAuth } from './use-docyrus-auth';

/**
 * Hook to get the pre-configured RestApiClient.
 * Returns null when not authenticated.
 *
 * Throws if used outside DocyrusAuthProvider.
 */
export function useDocyrusClient(): RestApiClient | null {
  const { client } = useDocyrusAuth();

  return client;
}
